import useIsMobile from "../hooks/useIsMobile";
import { useEffect, useState } from "react";
import GradientText from "../Components/GradientText/index";
import CountUp from "../Components/CountUp/index";
import axios from "axios";
import AnimatedContent from "./animatedContent/AnimatedContent";
// import arrowRight from "../imgs/arrowRight.svg";
// import { useNavigate } from "react-router-dom";
import arrowRight from "../imgs/arrowRight.svg";

import "./SecondPage.css";
import { useNavigate } from "react-router-dom";
function shuffleArray(array) {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
}

const SecondPage = () => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const [proofsGenerated, setProofsGenerated] = useState(58300162);
  const [uniqueAddresses, setUniqueAddresses] = useState(86759);
  // const [appRequests,setAppRequests] = useState(80578);
  const teamLogos = [
    { icon: "/ecosystemGrayIcon/PancakeSwap.svg", title: "PancakeSwap" },
    { icon: "/ecosystemGrayIcon/Algebra.svg", title: "Algebra" },
    { icon: "/ecosystemGrayIcon/QuickSwap.svg", title: "QuickSwap" },
    { icon: "/ecosystemGrayIcon/THENA.svg", title: "THENA" },
    { icon: "/ecosystemGrayIcon/OpenEden.svg", title: "OpenEden" },
    { icon: "/ecosystemGrayIcon/Usual.svg", title: "Usual" },
    { icon: "/ecosystemGrayIcon/Kernel.svg", title: "Kernel" },
    { icon: "/ecosystemGrayIcon/Bedrock.svg", title: "Bedrock" },
    { icon: "/ecosystemGrayIcon/Mellow.svg", title: "Mellow" },
    { icon: "/ecosystemGrayIcon/Euler.svg", title: "Euler" },
    { icon: "/ecosystemGrayIcon/BeraBorrow.svg", title: "BeraBorrow" },
    { icon: "/ecosystemGrayIcon/Kwenta.svg", title: "Kwenta" },
    { icon: "/ecosystemGrayIcon/JOJO.svg", title: "JOJO" },
    { icon: "/ecosystemGrayIcon/Trusta.svg", title: "Trusta" },
    { icon: "/ecosystemGrayIcon/Hemera.svg", title: "Hemera" },
    { icon: "/ecosystemGrayIcon/0G.svg", title: "0G" },
    { icon: "/ecosystemGrayIcon/Uniswap.svg", title: "Uniswap" },
    { icon: "/ecosystemGrayIcon/Celer.svg", title: "Celer" },
    // { icon: "/ecosystemGrayIcon/Gamma.svg", title: "Gamma" },
    { icon: "/ecosystemGrayIcon/Vana.svg", title: "Vana" },
    { icon: "/ecosystemGrayIcon/KiteAI.svg", title: "Kite AI" },
    { icon: "/ecosystemGrayIcon/YieldNest.svg", title: "YieldNest" },
    { icon: "/ecosystemGrayIcon/Metamask.svg", title: "Metamask" },
    { icon: "/ecosystemGrayIcon/Linea.svg", title: "Linea" },
    { icon: "/ecosystemGrayIcon/Turtle.svg", title: "Turtle" },
    { icon: "/ecosystemGrayIcon/beefy.svg", title: "beefy" },
  ];
  let newList = [];
  for (let i = 0; i < 20; i++) {
    newList = newList.concat(teamLogos);
  }

  const bottomLogos = shuffleArray(teamLogos);
  let newList2 = [];
  for (let i = 0; i < 20; i++) {
    newList2 = newList2.concat(bottomLogos);
  }
  const getData = () => {
    axios
      .get("https://explorer-gateway.brevis.network/v1/getAppsOverallData")
      .then((res) => {
        setProofsGenerated(res.data.totalProofs);
        setUniqueAddresses(res.data.totalUniqAddress);
        // setAppRequests(res.data.totalAppRequests);
      });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="PageContainer">
      <div className="secondPage" id="secondPage">
        <div className="scroll-container2">
          <div className="top_teams">
            <div className="scroll-content">
              {newList.map((logo, index) => (
                <div key={index} className="logo-itemOut">
                  <div className="logo-item">
                    <img
                      alt=""
                      className="team_icon"
                      src={logo.icon}
                      title={logo.title}
                    />
                    <img
                      alt=""
                      className="team_iconHover"
                      src={logo.icon.replace(
                        "ecosystemGrayIcon",
                        "ecosystemIcon"
                      )}
                      title={logo.title}
                    />
                    {!isMobile && (
                      <div className="logo-title">{logo.title}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* <img alt="" src={trust} /> */}
        <AnimatedContent
          type="bottom"
          id={"trustText"}
          key={"trustText"}
          duration={800}
        >
          <div className="trustText" key="trustText2">
            <GradientText
              colors={["#FF4400", "#2F5CFF", "#2FC1FF"]}
              animationSpeed={10}
              showBorder={false}
              className="custom-class"
            >
              Trusted by the <span className="bestText">{"{best}"}</span>
            </GradientText>
          </div>
        </AnimatedContent>

        <div className="content">
          <div className="data_item">
            <CountUp
              from={0}
              to={40}
              delay={0.3}
              separator=","
              direction="up"
              duration={1}
              className="count-up-text"
            />
            +{" "}
            <span
              className="data_des"
              style={{ color: "rgba(43, 48, 59, 0.6)", fontSize: "30px" }}
            >
              Partners
            </span>
          </div>
          <div className="data_item">
            <CountUp
              from={0}
              to={uniqueAddresses}
              separator=","
              direction="up"
              duration={1}
              className="count-up-text"
            />{" "}
            <span
              className="data_des"
              style={{ color: "rgba(43, 48, 59, 0.6)", fontSize: "30px" }}
            >
              Users
            </span>
          </div>
          <div className="data_item">
            <CountUp
              from={100000000}
              to={proofsGenerated}
              separator=","
              direction="up"
              duration={1}
              className="count-up-text"
            />{" "}
            <span
              className="data_des"
              style={{ color: "rgba(43, 48, 59, 0.6)", fontSize: "30px" }}
            >
              Proofs
            </span>
          </div>
        </div>

        <div className="links_container">
          <div
            className="linkEx use_cases_link"
            onClick={() => {
              const element = document.getElementById("casePage");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            [ See All Use Cases ]
            <img alt="" className="arrow_right" src={arrowRight} />
          </div>
          <div
            className="linkEx explore_built_link"
            onClick={() => {
              navigate("/ecosystem");
            }}
          >
            [ Explore What They Built ]
            <img alt="" className="arrow_right" src={arrowRight} />
          </div>
        </div>

        <div className="scroll-container">
          <div className="bottom_teams">
            <div className="scroll-content">
              {newList2.map((logo, index) => (
                <div key={index} className="logo-itemOut">
                  <div className="logo-item">
                    <img
                      alt=""
                      className="team_icon"
                      src={logo.icon}
                      title={logo.title}
                    />
                    <img
                      alt=""
                      className="team_iconHover"
                      src={logo.icon.replace(
                        "ecosystemGrayIcon",
                        "ecosystemIcon"
                      )}
                      title={logo.title}
                    />
                    {!isMobile && (
                      <div className="logo-title">{logo.title}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SecondPage;
